import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/joomla': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0.6 92.1C0.6 58.8 27.4 32 60.4 32 90.4 32 114.9 53.9 119.6 82.2 152.2 74.6 186.7 82.8 216.1 112.2L171.8 156.5C151.3 136 129.2 140.2 116.4 153 102.1 167.3 102.1 190.9 116.4 205.2L215.9 304.7 171.9 349C84.2 261.8 122.2 299.3 72.1 249.3 45.3 222.8 37.1 184.5 47.3 150.4 20.4 144.6 0.6 120.7 0.6 92.1zM130.1 208.5L174.4 252.8C184.4 242.8 264.1 163.1 274.1 153 288.4 138.7 311.7 138.7 326 153 338.8 165.8 343 188 322.5 208.4L366.5 252.7C397.7 221.5 405 185.1 395.4 151.5 424.6 147.4 447.3 122.3 447.3 92 447.3 58.8 420.5 31.9 387.5 31.9 357.2 31.9 332.1 54.4 328 83.5 294.2 73.6 256.3 82 229.7 108.6 211.4 127.7 158.6 180.1 130.1 208.5zM396.4 360.7C404.6 328 395.5 292.2 370.1 266.8 358.3 254.6 375.1 271.5 270.6 167.1L226.3 211.4 326 311.1C340.3 325.4 340.3 348.7 326 363 313.2 375.8 291 380 270.6 359.5L226.6 403.8C254.2 434 294.6 442.6 329.3 431.8 334.8 459.2 359 479.9 388.2 479.9 421.2 479.9 448 453.1 448 419.8 448 389.6 425.5 364.8 396.4 360.7zM312.1 307.6L268.1 263.3C181.1 349.7 217.7 313.7 168.4 363.1 154.1 377.4 130.8 377.4 116.5 363.1 103.4 349.7 99.6 327.8 119.7 307.7L75.7 263.4C45.5 293.6 37.7 328.6 46.2 361.7 19.5 367.7 0 391.6 0 419.9 0 453.2 26.8 480 59.8 480 88.4 480 112.3 460.2 118.4 433.3 151.1 441.5 186.9 432.7 212.6 407.3 244.7 375.3 224.8 394.9 312.1 307.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/joomla.js
// module id = KeEh
// module chunks = 144